export const maintenanceStartTime = new Date('2026-09-15T05:00:00');
export const maintenanceEndTime = new Date('2026-09-15T07:00:00');
export const displayStartTime = new Date('2026-09-10T12:00:00');
